import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/clientsConstants';

const initialState = {
  clients: [],
  client: null,
  loading: true,
  vehicles: [],
  vehiclesLoading: true,
  pageable: {
    totalPages: 1,
    last: true,
    first: true,
    size: 0,
    number: 0,
    totalElements: 0,
  },
  search: {
    search: '',
    page: 0,
    size: 10,
  },
};

const clientsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_CLIENTS:
      return {
        ...initialState,
      };
    case types.CLEAR_SELECTED_CLIENT:
      return {
        ...state,
        client: null,
      };
    case types.GET_CLIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        clients: payload.data,
        pageable: payload.pageable,
      };
    case types.GET_CLIENTS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_CLIENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SELECT_CLIENT:
      return {
        ...state,
        client: payload,
      };
    case types.GET_CLIENT_VEHICLES_SUCCESS:
      return {
        ...state,
        vehiclesLoading: false,
        vehicles: payload,
      };
    case types.GET_CLIENT_VEHICLES_FAILURE:
      return {
        ...state,
        vehiclesLoading: false,
      };
    case types.GET_CLIENT_VEHICLES_REQUEST:
      return {
        ...state,
        vehiclesLoading: true,
      };
    case types.CLEAR_CLIENT_VEHICLES:
      return {
        ...state,
        vehiclesLoading: true,
        vehicles: [],
      };
    case types.SET_CLIENTS_PAGE_SIZE:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          size: payload,
        },
      };
    case types.SET_CLIENTS_SEARCH:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          search: payload,
        },
      };
    case types.NEXT_CLIENTS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page + 1,
        },
      };
    case types.PREV_CLIENTS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page - 1,
        },
      };
    default:
      return state;
  }
};

export default clientsReducer;
